import { AlertState, AlertActionTypes, AlertTypes } from './types';
import { Reducer } from 'redux';
import { SharedActionTypes } from '../shared/types';

const initialState: AlertState = {
  message: '',
  type: AlertTypes.Initial,
  visible: false
};

const reducer: Reducer<AlertState> = (state = initialState, action) => {
  switch (action.type) {
    case AlertActionTypes.SHOW_ALERT: {
      return {
        ...state,
        visible: true,
        message: action.payload.message,
        type: action.payload.type
      };
    }
    case AlertActionTypes.HIDE_ALERT: {
      return {
        ...state,
        visible: false
      };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.ts` folder.
export { reducer as alertReducer };



// WEBPACK FOOTER //
// ./src/store/alert/reducer.ts